import { render, staticRenderFns } from "./Brochure.vue?vue&type=template&id=b709c6ee&"
import script from "./Brochure.vue?vue&type=script&lang=js&"
export * from "./Brochure.vue?vue&type=script&lang=js&"
import style0 from "./Brochure.vue?vue&type=style&index=0&id=b709c6ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports